module.exports = __webpack_public_path__ + "img/Shva_illustration.d990f21d.gif";